<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid overflow-auto" style="max-height: 860px;">

        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Office Registration</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-xl-12 col-md-12 mb-2">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary  mb-1">
                                    <form [formGroup]="officeForm" (ngSubmit)="onRegister()">
                                        <div class="row">
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Name</mat-label>
                                                        <input matInput formControlName="name" minlength="3" title="Name at least has 3 characters !">
                                                        <mat-error *ngIf="officeForm.controls.name.errors?.required">This field is required !</mat-error>
                                                        <mat-error *ngIf="officeForm.controls.name?.value">Name at least has 3 characters !</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Email</mat-label>
                                                        <input matInput formControlName="email">
                                                        <mat-error *ngIf="officeForm.controls.email.errors?.required">This field is required ! </mat-error>
                                                        <mat-error *ngIf="officeForm.controls.email.errors?.email">Require valid email format ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Client Id</mat-label>
                                                        <mat-select formControlName="clientId" class="text-primary">
                                                            <mat-option class="text-primary"
                                                                        *ngFor="let items of clientList"
                                                                        [value]="items.id">{{items.name}}</mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                                *ngIf="officeForm.controls.clientId.errors?.required">
                                                            This field is required !
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Number</mat-label>
                                                        <input matInput formControlName="number" type="tel" pmPhoneFormat>
                                                        <mat-error *ngIf="officeForm.controls.number.errors?.required">This field is required ! </mat-error>
                                                        <mat-error *ngIf="officeForm.controls.number.errors?.pattern">Invalid format! Use 555-123-4567</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Phone-Type</mat-label>
                                                        <mat-select formControlName="phoneType" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let phone of phoneType" [value]="phone.value">{{phone.viewValue}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="officeForm.controls.phoneType.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Address</mat-label>
                                                        <input matInput formControlName="firstLine" placeholder="First Line" >
                                                        <mat-error *ngIf="officeForm.controls.firstLine.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Second Line</mat-label>
                                                        <input matInput formControlName="secondLine" placeholder="First Line" >
                                                        <mat-error *ngIf="officeForm.controls.secondLine.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>City</mat-label>
                                                        <input matInput formControlName="city"  >
                                                        <mat-error *ngIf="officeForm.controls.city.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-xl-2" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>State</mat-label>
                                                        <mat-select formControlName="state" class="text-primary">
                                                            <mat-option class="text-primary" *ngFor="let type of stateList" [value]="type.value">{{type.label}}</mat-option>
                                                        </mat-select>
                                                        <mat-error *ngIf="officeForm.controls.state.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-xl-2 col-md-2" >
                                                <div class="form-group ">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Zip</mat-label>
                                                        <input matInput formControlName="zip" pmZipCode >
                                                        <mat-error *ngIf="officeForm.controls.zip.errors?.required">This field is required ! </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div *ngIf="officeId" class="col-xl-1 col-md-6 mt-3 pt-2" >
                                                <div [ngClass]="status ? 'active' : 'inactive'"><span class="text-primary">Status :</span> {{status ? 'Active' : 'Inactive'}}
                                                    <label class="switch">
                                                        <input type="checkbox" class="success" [checked]="this.status" (click)="changeStatus(this.status)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" routerLink="/office"
                                                class="btn btn-secondary float-end  waves-effect waves-light">Cancel</button>
                                        <button *ngIf="!officeId" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                [disabled]="!officeForm.valid">Register
                                        </button>
                                        <button *ngIf="officeId" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                [disabled]="!officeForm.valid">Update
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
